import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import storage from '../../lib/storage'
import { STATUS_LIVE } from '../../utils/constants'
import { API_URL, MUSIC_URL } from '../../fetcher/constants'

import { loginWithHash, getTsFromM3U8Link, getTSFileFromLink, getPatient } from '../../lib/api'
/**
 * @todo Alterar o local da função, para uma pasta "shared"
 */
import { examFactory } from '../../utils/functions'
import { useParams } from 'react-router-dom'
import Player from '../../components/player'
import { tsUrl } from '../../utils/ts-url'

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: black;
`

const EmbedPlayer = () => {
    const [patient, setPatient] = useState()
    const { exam, hash } = useParams()

    useEffect(() => {
        startingRequests()
    }, [])
    const startingRequests = async () => {
        try {
            await getShareTokenFromApi()
            await getPatientFromApi()
        } catch (error) {
            console.log(error)
        }
    }

    const redirect = (url) => {
        if (typeof window !== 'undefined' && url) {
            window.location.href = url
        }
    }

    const getShareTokenFromApi = async () => {
        try {
            const { data } = await loginWithHash({ exam, hash })
            storage.saveSession(data)
        } catch (error) {
            console.error('Erro no login com hash:', error)
        }
    }

    const getPatientFromApi = async () => {
        try {
            const { payment, data } = await getPatient()

            if (payment) {
                redirect(payment)
                return
            }

            const patientData = examFactory(data)
            const { introURL, m3u8, mp4Url, date, examId, cycle } = patientData

            let vmusicError = false
            let useM3U8 = false
            let kalturaM3u8 = ''

            try {
                const response = await fetch(`${API_URL}/patient/media/${examId}/${cycle}/vmusic-token`, {
                headers: {
                    Authorization: `Bearer ${storage.getToken()}`,
                },
                })
                const token = await response.text()
                kalturaM3u8 = `${MUSIC_URL}/v1/vlab/m3u8/${examId}/${token}/vod.m3u8`
                const optionsResponse = await fetch(kalturaM3u8)
                if (!optionsResponse.ok) {
                    throw new Error('M3U8 não disponível')
                }
                useM3U8 = true
            } catch (e) {
                console.error('Falha ao obter vmusic-token, usando m3u8 direto:', e)
                vmusicError = true
                const responseM3U8 = await getTsFromM3U8Link(m3u8)
                if (responseM3U8) {
                    useM3U8 = true
                }
            }

            if (useM3U8) {
                if (!vmusicError) {
                    setPatient({
                        intro: introURL || '',
                        src: kalturaM3u8,
                        type: 'application/x-mpegURL',
                        date,
                    })
                } else if (mp4Url) {
                    setPatient({
                        intro: introURL || '',
                        src: mp4Url,
                        type: 'video/mp4',
                        date,
                    })
                } else if (m3u8) {
                    setPatient({
                        intro: introURL || '',
                        src: m3u8,
                        type: 'application/x-mpegURL',
                        date,
                    })
                } else {
                    setPatient({
                        intro: '',
                        src: '',
                        type: 'video/mp4',
                        date,
                    })
                }
            } else {
                setPatient({
                    intro: introURL || '',
                    src: mp4Url,
                    type: 'video/mp4',
                    date,
                })
            }
        } catch (error) {
            console.error('embed player error', error)
        }
    }

    return (
        <StyledContainer>
            {patient ? (
                <Player
                options={{
                    sources: [
                    { src: patient.intro, type: 'video/mp4' },
                    { src: patient.src, type: patient.type },
                    ],
                }}
                isLive={patient.examStatus === STATUS_LIVE}
                />
            ) : (
                <p style={{ color: 'white', padding: 16 }}>Carregando...</p>
            )}
        </StyledContainer>
    )
}

export default EmbedPlayer
